import { createContext } from 'react';
import utils from '../../utils';
import { DataRoomNode } from 'router/subrouters/DataRoom/models/DataRoomNode';

type DocumentViewContextValues = {
  openNode: (node: DataRoomNode, dataRoomName?: string) => void;
};

export default createContext<DocumentViewContextValues>({
  openNode: utils.noop,
});
